/**
 * promptQueue — at most ONE interstitial prompt per browser session.
 * Any prompt (PWA install, UPI onboarding, …) calls claimPrompt() before
 * showing itself; the first caller wins and the rest stay quiet until the
 * next session.
 */
const KEY = 'interstitial_prompt_claimed';

export function claimPrompt(name) {
  try {
    const current = sessionStorage.getItem(KEY);
    if (current && current !== name) return false;
    sessionStorage.setItem(KEY, name);
    return true;
  } catch {
    return true;
  }
}

export function releasePrompt(name) {
  try {
    if (sessionStorage.getItem(KEY) === name) sessionStorage.removeItem(KEY);
  } catch { /* ignore */ }
}
